import { Sickness } from '@work4all/models/lib/Classes/Sickness.entity';
import { Vacation } from '@work4all/models/lib/Classes/Vacation.entity';

export function isVacationApproved(vacation: Vacation | Sickness): boolean {
  return vacation.applicationDate == null || vacation.approveDate != null;
}
